import { ICourseRequest } from '@core/interfaces';
import { Course } from './course.entity';
import { Entity } from './entity';

export class CourseRequest extends Entity<ICourseRequest> {
  constructor(props: ICourseRequest) {
    super(props);
  }

  get id() {
    return this.props.id;
  }

  get status() {
    return this.props.status;
  }
  get course() {
    return this.props.course && new Course(this.props.course);
  }
  get user() {
    return (this.props.user?.firstName ?? '') + ' ' + (this.props.user?.lastName ?? '');
  }
  get key() {
    return this.props.key;
  }
}
